module.exports = __webpack_public_path__ + "51548f8d6c1daa9a94a1afea49b21a6a.jpg";